module.exports = __webpack_public_path__ + "AdvancedDiplomain3DGameArtDigitalSculpting-e2c4ebca.webp";